import { render } from "./PageLoader.vue?vue&type=template&id=2e371d9f"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"
script.render = render

export default script